/** Attributes for 0–99 style score fields (numeric keyboard, no spinners). */
export const mobileScoreInputAttrs = {
  type: 'text',
  inputMode: 'numeric',
  pattern: '[0-9]*',
  autoComplete: 'off',
  autoCapitalize: 'none',
  autoCorrect: 'off',
  spellCheck: false,
};

/** Skip clear-on-focus once after programmatic focus (e.g. auto-advance to next score box). */
let skipClearForField = null;

/**
 * Call before `input.focus()` when advancing between score fields so the destination is not wiped.
 * @param {'team1'|'team2'} fieldId
 */
export function markSkipMobileScoreClear(fieldId) {
  skipClearForField = fieldId;
}

/**
 * Score field focus: clear the value so the user can re-type without fighting the cursor.
 *
 * @param {React.FocusEvent<HTMLInputElement>} event
 * @param {'team1'|'team2'} fieldId
 * @param {() => void} onClear — set parent state to '' for this field
 */
export function handleMobileScoreFocus(event, fieldId, onClear) {
  if (typeof onClear !== 'function') return;

  if (skipClearForField === fieldId) {
    skipClearForField = null;
    return;
  }

  const input = event.target;
  onClear();

  requestAnimationFrame(() => {
    input.focus({ preventScroll: true });
  });
}

/** @internal test helper */
export function resetMobileScoreClearSkipForTests() {
  skipClearForField = null;
}
